import docs from '../../data/docs';
import fallbackBooks from '../books/booksData';
import {
  getArticles,
  getBooks,
  normalizeArticle,
  normalizeBook,
} from '../../services/contentApi';

export const ACADEMY_CATEGORIES = {
  books: '推荐书籍',
  articles: '财富认知',
  guides: '交易所教程',
};

export function normalizeAcademyBook(book) {
  return normalizeBook(book);
}

export function normalizeAcademyArticle(article) {
  return normalizeArticle(article);
}

export async function fetchAcademyBooks() {
  try {
    const books = await getBooks();
    if (books.length) {
      return books;
    }
  } catch {}

  return fallbackBooks.map(normalizeAcademyBook);
}

export async function fetchAcademyDocs() {
  const result = await fetchAcademyDocsResult();
  return result.docs;
}

export async function fetchAcademyDocsResult() {
  try {
    const articles = await getArticles();
    if (Array.isArray(articles)) {
      return {
        docs: articles,
        source: 'api',
        error: null,
      };
    }
    throw new Error('Articles API returned an invalid payload');
  } catch (error) {
    return {
      docs: docs.map(normalizeAcademyArticle),
      source: 'fallback',
      error,
    };
  }

}

export { docs as fallbackAcademyDocs, fallbackBooks };
